import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Col } from 'reactstrap';
import IsnIntegration from '../../shared/IsnIntegration';
import LabeledInput from '../../shared/LabeledTextInput';
import Checkbox from '../../shared/Checkbox';
import styles from './styles.scss';

class SubscriptionPreferences extends React.Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      canEdit: PropTypes.bool,
      company: PropTypes.object,
      onFieldChange: PropTypes.func,
    };
  }

  render() {
    const { canEdit, company, onFieldChange } = this.props;

    const className = classNames(styles.checkboxLabel, {
      [styles.enabled]: canEdit,
      [styles.disabled]: !canEdit,
    });

    const sideContent = 
      <If condition={company}>
        <Col md={12}>
          <div className={styles.isnCheckbox}>
            <Checkbox disabled={!canEdit} checked={company.isIsn} onChange={value => { canEdit ? onFieldChange('isIsn', value) : {} }} />
            <span
              onClick={() => { canEdit ? onFieldChange('isIsn', !company.isIsn) : {} }}
              className={className}
            >
              ISN Integration On/Off
            </span>
          </div>

            <LabeledInput
              editMode={ canEdit && company.isIsn }
              label='ISN Company Key'
              value={company.isnKey}
              allowBlank={false}
              onChange={value => { onFieldChange('isnKey', value) }}
            />

            <LabeledInput
              editMode={ canEdit && company.isIsn }
              label='Domain'
              value={company.isnDomain}
              allowBlank={false}
              onChange={value => { onFieldChange('isnDomain', value) }}
            />
        </Col> 
      </If>

    return (
      <IsnIntegration sideContent={sideContent} />
    );
  }
}
export default SubscriptionPreferences;



// WEBPACK FOOTER //
// src/components/companyDetails/SubscriptionPreferences/index.jsx